import { Activity, ActivityDataTimelineProps, ActivityParticipatedPlayer } from "@/types/activity"
import {
  ReadSessionDataItemsResponse,
  Session,
  SessionCropData,
  SessionData,
} from "@/types/session"
import { PlayerDevice } from "@/types/device"
import SimpleBarCore from "simplebar-core"
import { Dispatch, SetStateAction } from "react"

export type ActivityDetailModeProps = {
  activityInfo?: Activity
  sessionList?: Session[]
  middleOfScrollBarSetter: () => void
  activityTimelineContRef: React.RefObject<SimpleBarCore | null>

  groupedActivityData: ActivityDataTimelineProps[]
  playerSessionDataMap?: Record<number, SessionData[]>
  teamDeviceList?: PlayerDevice[]
  playerList?: ActivityParticipatedPlayer[]
  onEditClick?: () => void
}

export type ActivityCropModeProps = ActivityDetailModeProps & {
  sessionDataList: (ReadSessionDataItemsResponse | null | undefined)[]
  groupedActivityData: ActivityDataTimelineProps[]
  localSessionCropHistory: LocalSessionCropHistory[]
  tempSessionCropHistory: LocalSessionCropHistory[]
  setLocalSessionCropHistory: Dispatch<SetStateAction<LocalSessionCropHistory[]>>
  setTempSessionCropHistory: Dispatch<SetStateAction<LocalSessionCropHistory[]>>
}

export enum CropType {
  delete = "delete",
  add = "add",
  copy = "copy",
  paste = "paste",
  copyAll = "copyAll",
  cancel = "cancel",
}

export enum CropOption {
  applyAll = "applyAll",
  copy = "copy",
  undo = "undo",
  cancel = "cancel",
}

export type LocalSessionCropHistory = {
  localIdfCropNumber?: string
  actionType: CropType

  history: LocalSessionCropData[]
}

export type LocalSessionCropData = Partial<SessionCropData> & {
  idfData: number
  cropStartTime: number | string
  cropEndTime: number | string
  idfSessionCropRecord: number
  localIdfCropNumber?: string
  idfSession?: number
}
